import { render, staticRenderFns } from "./ManageRequests.vue?vue&type=template&id=67a005c4"
import script from "./ManageRequests.vue?vue&type=script&lang=js"
export * from "./ManageRequests.vue?vue&type=script&lang=js"
import style0 from "./ManageRequests.vue?vue&type=style&index=0&id=67a005c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports